import React from "react";
import { Grid, Container, Box } from "@mui/material";
import Greeting from "../FinalDashboard/Greeting";
import Cards from "../FinalDashboard/Cards";
import Records from "../FinalDashboard/Records";
import TotalBalanceChart from "../FinalDashboard/TotalBalanceChart";
import PerformanceGraph from "../FinalDashboard/PerformanceGraph";
import MyCards from "../FinalDashboard/MyCards";
import RetailerTotalServices from "./RetailerTotalServices";
import RetailersPerformanceGraph from "./RetailersPerformanceGraph";
import RetailerCards from "./RetailerCards";
import ToggleActivation from "./ToggleActivation";
import PayoutToggle from "./PayoutToggle";

const DashboardFinal = () => {
  const userType = sessionStorage.getItem("uType");
  const hasPermission = (key) => sessionStorage.getItem(key) === "true";

  return (
    <Box sx={{ padding: 3, marginTop: { xs: "20%", md: "5%" } }}>
      <Grid container spacing={3}>
          <Grid item xs={12} sx={{ display: "flex", justifyContent: "end", gap:"10px" }}>
        {(userType === "ADMIN" || (userType === "SUBADMIN" && hasPermission("ActivateDeactivateAll"))) && (
            <ToggleActivation />
        )}
                {(userType === "ADMIN" || (userType === "SUBADMIN" && hasPermission("AutomatePayout"))) && (
                  <PayoutToggle />
                )}
          </Grid>
        <Grid item xs={12}>
          <Greeting />
        </Grid>

        {userType === "RETAILER" ? (
          <Grid item xs={12} sm={12}>
            <RetailerCards />
          </Grid>
        ) : (
          <Grid item xs={12} sm={6}>
            <Cards />
          </Grid>
        )}
        {userType !== "RETAILER" && (
          <Grid item xs={12} sm={6}>
            <Records />
          </Grid>
        )}
        <Grid item xs={12} sm={6}>
          {userType === "RETAILER" ? (
            <RetailerTotalServices />
          ) : (
            <TotalBalanceChart />
          )}
        </Grid>
        {userType === "RETAILER" ? (
          <Grid item xs={12} sm={6}>
            <RetailersPerformanceGraph />
          </Grid>
        ) : (
          <Grid item xs={12} sm={6}>
            <PerformanceGraph />
          </Grid>
        )}
        {/* <Grid item xs={12}>
                <MyCards />
            </Grid> */}
      </Grid>
    </Box>
  );
};

export default DashboardFinal;
